import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ThemeMode = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly THEME_KEY = 'app_theme';
  private currentTheme$ = new BehaviorSubject<ThemeMode>('dark');

  constructor() {
    this.init();
  }

  private init() {
    const savedTheme = localStorage.getItem(this.THEME_KEY) as ThemeMode;
    const theme = savedTheme || 'dark';
    this.setTheme(theme);
  }

  getTheme() {
    return this.currentTheme$.asObservable();
  }

  getCurrentTheme(): ThemeMode {
    return this.currentTheme$.value;
  }

  setTheme(theme: ThemeMode) {
    this.currentTheme$.next(theme);
    localStorage.setItem(this.THEME_KEY, theme);
    this.applyTheme(theme);
  }

  private applyTheme(theme: ThemeMode) {
    const body = document.body;

    // Remover clases existentes
    body.classList.remove('dark-theme', 'light-theme');

    // Aplicar tema manual
    body.classList.add(`${theme}-theme`);
  }

  toggleTheme() {
    const current = this.getCurrentTheme();
    const next: ThemeMode = current === 'light' ? 'dark' : 'light';

    this.setTheme(next);
    return next;
  }
}
